import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const IntegrationsListSection = styled.section`
  margin: ${Spacing.S16} 0 ${Spacing.S32};
`

export const IntegrationsListWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`
